// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderAccordionItems-orderCardItemContainer-vaqLo {
    border: 1px solid var(--primary-border);
    border-radius: var(--radius-2);
    background: var(--background-primary);
}

.OrderAccordionItems-orderCardItemWrapper-KoOK3 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.OrderAccordionItems-orderCardItemImgContainer-jbxkZ {
    position: relative;
    width: 69px;
    height: 69px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.OrderAccordionItems-orderCardItemImgContainer-jbxkZ img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
    -o-object-position: center;
       object-position: center;
}

.OrderAccordionItems-orderCardItemInfoType-YiEoI {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    width: 100%;
    text-align: start;
}

.OrderAccordionItems-orderAccordionBodyMediaItemContainer-EX_Mb {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    padding: 12px;
    border-top: 1px solid var(--primary-border);
    gap: 24px;
    grid-gap: 24px;
}

.OrderAccordionItems-orderAccordionMediaItem-qo_DV {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    grid-gap: 12px;
}

.OrderAccordionItems-orderAccordionBodyTotalBtnContainer-Gow6l {
    padding: 0 12px 12px;
}

.OrderAccordionItems-orderAccordionBodyTotalBtn-xZci0 {
    border: 1px solid var(--primary-border);
    padding: 9px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    color: var(--primary-foreground);
    text-align: center;
    border-radius: var(--radius-1);
}

@media (max-width: 575px) {
    .OrderAccordionItems-orderAccordionBodyMediaItemContainer-EX_Mb {
        row-gap: 12px;
        -webkit-column-gap: 18px;
           -moz-column-gap: 18px;
                column-gap: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetail/OrderAccordionItems/OrderAccordionItems.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kDAAkD;IAClD,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;IACtB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAe;QAAf,eAAe;IACf,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI;QACI,aAAa;QACb,wBAAgB;WAAhB,qBAAgB;gBAAhB,gBAAgB;IACpB;AACJ","sourcesContent":[".orderCardItemContainer {\n    border: 1px solid var(--primary-border);\n    border-radius: var(--radius-2);\n    background: var(--background-primary);\n}\n\n.orderCardItemWrapper {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n    flex-grow: 1;\n}\n\n.orderCardItemImgContainer {\n    position: relative;\n    width: 69px;\n    height: 69px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n    flex-shrink: 0;\n}\n\n.orderCardItemImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n    object-position: center;\n}\n\n.orderCardItemInfoType {\n    flex-grow: 1;\n    width: 100%;\n    text-align: start;\n}\n\n.orderAccordionBodyMediaItemContainer {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    padding: 12px;\n    border-top: 1px solid var(--primary-border);\n    gap: 24px;\n    grid-gap: 24px;\n}\n\n.orderAccordionMediaItem {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.orderAccordionBodyTotalBtnContainer {\n    padding: 0 12px 12px;\n}\n\n.orderAccordionBodyTotalBtn {\n    border: 1px solid var(--primary-border);\n    padding: 9px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n    color: var(--primary-foreground);\n    text-align: center;\n    border-radius: var(--radius-1);\n}\n\n@media (max-width: 575px) {\n    .orderAccordionBodyMediaItemContainer {\n        row-gap: 12px;\n        column-gap: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderCardItemContainer": `OrderAccordionItems-orderCardItemContainer-vaqLo`,
	"orderCardItemWrapper": `OrderAccordionItems-orderCardItemWrapper-KoOK3`,
	"orderCardItemImgContainer": `OrderAccordionItems-orderCardItemImgContainer-jbxkZ`,
	"orderCardItemInfoType": `OrderAccordionItems-orderCardItemInfoType-YiEoI`,
	"orderAccordionBodyMediaItemContainer": `OrderAccordionItems-orderAccordionBodyMediaItemContainer-EX_Mb`,
	"orderAccordionMediaItem": `OrderAccordionItems-orderAccordionMediaItem-qo_DV`,
	"orderAccordionBodyTotalBtnContainer": `OrderAccordionItems-orderAccordionBodyTotalBtnContainer-Gow6l`,
	"orderAccordionBodyTotalBtn": `OrderAccordionItems-orderAccordionBodyTotalBtn-xZci0`
};
module.exports = ___CSS_LOADER_EXPORT___;
